module.exports = __webpack_public_path__ + "static/turtle-creek-house07-b1bee167725b7a6a5dfefe967790e5e0.jpg";